function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["alignSelf", "area", "children", "columnEnd", "columnStart", "component", "justifySelf", "responsive", "rowEnd", "rowStart", "uiTheme"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import withTheme from '../Theme/withTheme';
import gridItemPropsToCss from './props-to-css';
import renderByCloning from '../../utils/renderByCloning';
var GridItem = function GridItem(_ref) {
  var alignSelf = _ref.alignSelf,
    area = _ref.area,
    children = _ref.children,
    columnEnd = _ref.columnEnd,
    columnStart = _ref.columnStart,
    component = _ref.component,
    justifySelf = _ref.justifySelf,
    responsive = _ref.responsive,
    rowEnd = _ref.rowEnd,
    rowStart = _ref.rowStart,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return renderByCloning(component, children, _objectSpread({}, otherProps));
};
GridItem.propTypes = {
  alignSelf: PropTypes.string,
  area: PropTypes.string,
  children: PropTypes.any,
  columnEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columnStart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  component: PropTypes.string,
  justifySelf: PropTypes.string,
  responsive: PropTypes.arrayOf(PropTypes.shape({
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    props: PropTypes.object
  })),
  rowEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowStart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.shape(),
  uiTheme: PropTypes.object
};
GridItem.defaultProps = {
  alignSelf: null,
  area: null,
  children: null,
  columnEnd: null,
  columnStart: null,
  component: null,
  justifySelf: null,
  responsive: [],
  rowEnd: null,
  rowStart: null,
  style: {},
  uiTheme: {}
};
var StyledGridItem = styled(GridItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return gridItemPropsToCss(props);
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    return gridItemPropsToCss(_objectSpread({
      uiTheme: uiTheme
    }, breakpointProps));
  });
});
export default withTheme(StyledGridItem);